import React, { forwardRef, ComponentProps } from 'react';

import theme from '@adsk/alloy-react-theme';

import Icon, { generateRenderedIcon, IconWithRender } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16TopPx =
  'M9.993 4.252h-6.18l1.64-1.64a.75.75 0 1 0-1.06-1.06l-2.92 2.92a.776.776 0 0 0-.22.53.776.776 0 0 0 .22.53l2.92 2.91a.725.725 0 0 0 .53.22.742.742 0 0 0 .53-.22.754.754 0 0 0 0-1.06l-1.64-1.63h6.18a.75.75 0 1 0 0-1.5Z';

const draw16BottomPx =
  'M14.743 11c.002.05-.001.1-.01.15v.002a.937.937 0 0 1-.041.137.672.672 0 0 1-.098.166.863.863 0 0 1-.061.075h-.01l-2.91 2.91a.741.741 0 0 1-.53.22.725.725 0 0 1-.53-.22.754.754 0 0 1 0-1.06l1.63-1.63h-6.19a.75.75 0 1 1 0-1.5h6.19l-1.63-1.64a.75.75 0 0 1 1.06-1.06l2.91 2.92h.01v.002a.909.909 0 0 1 .047.057.674.674 0 0 1 .163.47Z';

const draw24TopPx =
  'M15.263 7.3h-9.4L7.5 5.671a.754.754 0 0 0-.53-1.285.737.737 0 0 0-.53.225l-2.92 2.91a.776.776 0 0 0-.22.53.776.776 0 0 0 .22.53l2.92 2.92a.75.75 0 0 0 .53.22.786.786 0 0 0 .53-.22.754.754 0 0 0 0-1.06L5.863 8.8h9.4a.75.75 0 1 0 0-1.5Z';

const draw24BottomPx =
  'M20.75 16.335a.716.716 0 0 0 0-.58.776.776 0 0 0-.16-.24l-2.92-2.91a.739.739 0 0 0-1.06 0 .754.754 0 0 0 0 1.06l1.64 1.63h-9.5a.75.75 0 1 0 0 1.5h9.5l-1.64 1.64a.754.754 0 0 0 0 1.06.786.786 0 0 0 .53.22.749.749 0 0 0 .53-.22l2.92-2.92a.776.776 0 0 0 .16-.24Z';

const iconsTop: IconVariations = {
  _16: { d: draw16TopPx, viewBox: VIEWBOXES._16 },
  _24: { d: draw24TopPx, viewBox: VIEWBOXES._24 },
};

const iconsBottom: IconVariations = {
  _16: {
    d: draw16BottomPx,
    viewBox: VIEWBOXES._16,
    fill: theme.tokens.colors.icon.inactive.value,
  },
  _24: {
    d: draw24BottomPx,
    viewBox: VIEWBOXES._24,
    fill: theme.tokens.colors.icon.inactive.value,
  },
};

const ArrowsIncomingIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>(
  generateRenderedIcon([iconsTop, iconsBottom], 'arrowsIncoming'),
) as IconWithRender;

ArrowsIncomingIcon.displayName = 'ArrowsIncomingIcon';
ArrowsIncomingIcon.propTypes = Icon.propTypes;
ArrowsIncomingIcon.renderIcon = (props) => <ArrowsIncomingIcon {...props} />;
export default ArrowsIncomingIcon;
